import { toast } from 'sonner';
import { STRINGS } from '../i18n/strings';
import { localize } from '../i18n/LanguageContext';

// Glass-morphism styled toast (see `.glass-toast` in onyx-tokens.css) shown
// when a store button is clicked but the app doesn't have that link yet.
export function showStoreUnavailable(label, lang = 'en') {
  const prefix = localize(STRINGS.storeComingSoon, lang);
  toast(`${prefix} ${label}`, { className: 'glass-toast', duration: 2600 });
}
